'use strict';

var dateFns = require('date-fns');

const DEFAULT_OPTIONS = {
  units: ["days", "hours", "minutes", "seconds", "milliseconds"]
};
const parseMillisecondsToTimeDuration = (milliseconds, options = {}) => {
  const { units } = { ...DEFAULT_OPTIONS, ...options };
  const timeDuration = {};
  let restMilliseconds = Math.abs(milliseconds);
  const sign = Math.sign(milliseconds);
  if (units.includes("days")) {
    timeDuration.days = Math.floor(dateFns.millisecondsToHours(restMilliseconds) / 24);
    restMilliseconds = restMilliseconds - dateFns.hoursToMilliseconds(timeDuration.days * 24);
  }
  if (units.includes("hours")) {
    timeDuration.hours = dateFns.millisecondsToHours(restMilliseconds);
    restMilliseconds = restMilliseconds - dateFns.hoursToMilliseconds(timeDuration.hours);
  }
  if (units.includes("minutes")) {
    timeDuration.minutes = dateFns.millisecondsToMinutes(restMilliseconds);
    restMilliseconds = restMilliseconds - dateFns.minutesToMilliseconds(timeDuration.minutes);
  }
  if (units.includes("seconds")) {
    timeDuration.seconds = dateFns.millisecondsToSeconds(restMilliseconds);
    restMilliseconds = restMilliseconds - dateFns.secondsToMilliseconds(timeDuration.seconds);
  }
  if (units.includes("milliseconds")) {
    timeDuration.milliseconds = restMilliseconds;
    restMilliseconds = restMilliseconds - timeDuration.milliseconds;
  }
  Object.entries(timeDuration).forEach(([k, v]) => {
    timeDuration[k] = v * sign;
  });
  return timeDuration;
};

module.exports = parseMillisecondsToTimeDuration;
//# sourceMappingURL=parseMillisecondsToTimeDuration.cjs.map
